var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropDownFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85227 9.9106L6.14844 8.61719L11.0004 13.4654L15.8523 8.61719L17.1484 9.91427L12.2965 14.7588C11.9527 15.1025 11.4865 15.2956 11.0004 15.2956C10.5142 15.2956 10.048 15.1025 9.70419 14.7588L4.85227 9.9106Z",
    fill: "#331400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownFilledIcon);
export default __webpack_public_path__ + "static/media/dropDownFilledIcon.f02cd5795c7d30916412954b3cf304cb.svg";
export { ForwardRef as ReactComponent };